export default {
  feedback: {
    login_success: 'Sessão iniciada com sucesso',
    logout_success: 'Sessão terminada com sucesso',
  },
};
